// Client-side mirror of the server's admin password policy (AdminPasswordPolicy, app-service)
// for immediate feedback. The server re-validates everything and stays authoritative.

export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;
const ADMIN_USERNAME = "admin";
const BOOTSTRAP_PASSWORD = "admin";

export type PasswordChangeError =
  | "currentRequired"
  | "mismatch"
  | "length"
  | "notAllowed";

export interface PasswordChangeInput {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export function validatePasswordChange(input: PasswordChangeInput): PasswordChangeError | null {
  const { currentPassword, newPassword, confirmPassword } = input;
  if (!currentPassword) return "currentRequired";
  if (newPassword !== confirmPassword) return "mismatch";
  if (newPassword.length < PASSWORD_MIN_LENGTH || newPassword.length > PASSWORD_MAX_LENGTH) return "length";
  if (
    newPassword.trim() === "" ||
    newPassword === currentPassword ||
    newPassword.toLowerCase() === BOOTSTRAP_PASSWORD ||
    newPassword.trim().toLowerCase() === ADMIN_USERNAME
  ) return "notAllowed";
  return null;
}

/** Map a server VC-AUTH-* problem code from the password endpoint to a form error. */
export function passwordErrorFromCode(code: string | undefined): PasswordChangeError | "currentIncorrect" | null {
  switch (code) {
    case "VC-AUTH-012": return "currentIncorrect";
    case "VC-AUTH-013": return "mismatch";
    case "VC-AUTH-014": return "length";
    case "VC-AUTH-015": return "notAllowed";
    default: return null;
  }
}
